
const createHash = require('create-hash');

function hashIt(input: Uint8Array) : Uint8Array {

  const hash = createHash('sha512');
  hash.update('synchronous write'); // optional encoding parameter
  hash.digest(); // synchronously get result with optional encoding parameter
  hash.write(input);
  hash.end(); // remember it's a stream
  const x = hash.read(); // only if you ended it as a stream though
  return x;
  // console.log(x);

}

export function derivePKfromCodeWord(codeword: string) : Promise<string> {

  const result = new Promise<string>((resolve, reject) => {
    console.log('starting to decodePK from CodeWord');
    const enc = new TextEncoder();
    let array = enc.encode(codeword);

    for (let counter:number = 1; counter < 97646; counter++) {
      array = hashIt(array);
      // console.log('result: ', array);
    }

    // console.log('PK: ', array);

    array = array.slice(13, 45);
    const bufferForPK = Buffer.from(array);
    //return bufferForPK.toString('hex');
    resolve(bufferForPK.toString('hex'));
  });

  console.log('returning promise');
  return result;
}

export default derivePKfromCodeWord;
